import React from "react";
import { useData } from "../contexts/DataContext";
import Features from "../partials/Features";
import Hero from "../partials/Hero";
import FeaturedEvents from "../partials/FeaturedEvents";
import Mission from "../partials/Mission";
import { ALIGNMENT_CLASSES } from "../utils/constants";
import LaunchPartner from "../partials/LaunchPartner";
import Footer from "../components/Footer";

const Home: React.FC = () => {
  const { eventsData, loading } = useData();
  const featuredEvents = eventsData.slice(0, 4);
  return (
    <div>
      <Hero alignmentClasses={ALIGNMENT_CLASSES} />
      {
        process.env.REACT_APP_MESSAGING !== "research" && (
      <Features alignmentClasses={ALIGNMENT_CLASSES} />)
      }

      {/* TODO: we are hiding featured events on home page prod untill we launch */}
      {process.env.REACT_APP_ENVIRONMENT !== "production" && (
        <FeaturedEvents
          alignmentClasses={ALIGNMENT_CLASSES}
          featuredEvents={featuredEvents}
        />
      )}
      {process.env.REACT_APP_ENVIRONMENT === "production" &&  process.env.REACT_APP_MESSAGING !== "research" && (
        <LaunchPartner alignmentClasses={ALIGNMENT_CLASSES} />
      )}
      <Mission alignmentClasses={ALIGNMENT_CLASSES} />
      <Footer />
    </div>
  );
};

export default Home;
